import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { Row, FormRow, Col } from '../../../../../1stlog-ui/src/components/Bootstrap'
import Card from '../../../../../1stlog-ui/src/components/Card'
import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Badge from '../../../../../1stlog-ui/src/components/Badge'
import Field, { useField } from '../../../../../1stlog-ui/src/components/Field'
import DateSelect from './DateSelect'
import ProductSelect from './ProductSelect'
import ProductHandler from './ProductHandler'
import ProductLoader from './ProductLoader'
import ProviderSelect from './ProviderSelect'
import { ProductsContextProvider } from '../../Products/ProductsContext'
import useOrderEntry from '../../useOrderEntry'
import ProviderLogo from './ProviderLogo'
import useTransport from './useTransport'
import RequireHint from './RequireHint'
import SlaSelect from './SlaSelect'

const Transport = (props) => {
  const {} = props

  const {
    preset,
    // if not internal, disallow usage of pickup AND delivery products
    isInternal
  } = useOrderEntry()

  // const {
  //   allowPickupProduct,
  //   allowDeliveryProduct,
  //   isPickupAndDelivery
  // } = preset

  const [isPickup, setIsPickup] = useField('isPickup', { asState: true })
  const [isDelivery, setIsDelivery] = useField('isDelivery', { asState: true })

  const isPickupEdit = useField('pickup.isEdit')
  const isDeliveryEdit = useField('delivery.isEdit')

  useEffect(() => {
    if (isInternal) {
      setTimeout(() => {
        setIsPickup(true)
      }, 0)
      return
    }
    setTimeout(() => {
      if (isPickupEdit) {
        setIsPickup(true)
        if (!isInternal) {
          setIsDelivery(false)
        }
      } else {
        setIsPickup(false)
        setIsDelivery(true)
      }
    }, 0)
  }, [isPickupEdit])

  useEffect(() => {
    if (isInternal || !isPickupEdit) {
      setTimeout(() => setIsDelivery(true), 0)
    }
  }, [isDeliveryEdit])

  const { isMixedTransport, requirePickupProduct, requireDeliveryProduct } = useTransport()

  const allowPickupProduct = isPickup || requirePickupProduct
  const allowDeliveryProduct = isDelivery || requireDeliveryProduct

  const isPickupAndDelivery = isPickup && isDelivery

  return (
    <>
      {isInternal && (
        <Card title={i18n.t("transport_settings", "Transporteinstellungen")}>
          <FormRow>
            <Col md={4}>
              <div className="">
                <SlaSelect />
              </div>
            </Col>
          </FormRow>
          {false && (
            <div className="d-flex mt-1">
              <div className="mr-2">Haupttransport</div>
              <div className="mr-2">
                <Field name="isPickup">
                  <Checkbox>Abholung</Checkbox>
                </Field>
              </div>
              <div>
                <Field name="isDelivery">
                  <Checkbox>Zustellung</Checkbox>
                </Field>
              </div>
              {isMixedTransport && (
                <div className="ml-2">
                  <Badge info>Mischtransport aktiv</Badge>
                </div>
              )}
            </div>
          )}
        </Card>
      )}
      {allowPickupProduct && (
        <Card
          title={
            isPickupAndDelivery
              ? i18n.t('transport_pickup', 'Abholung')
              : i18n.t('transport_general', 'Transport')
          }
          customContentPaddingClass="p-0"
        >
          <ProductsContextProvider id="pickup">
            {requirePickupProduct && <RequireHint isPickup />}
            <ProductHandler />
            <ProductLoader isPickup />
            <div className="px-2 pt-2">
              <Row>
                <ProviderSelect onlyAllowBasic={requirePickupProduct} />
                <Col className="d-flex">
                  <DateSelect isPickup />
                </Col>
                <ProviderLogo />
              </Row>
              <ProductSelect isPickup />
            </div>
          </ProductsContextProvider>
        </Card>
      )}
      {allowDeliveryProduct && (
        <Card
          title={
            isPickupAndDelivery
              ? i18n.t('transport_delivery', 'Zustellung')
              : i18n.t('transport_general', 'Transport')
          }
          customContentPaddingClass="p-0"
        >
          <ProductsContextProvider id="delivery">
            {requireDeliveryProduct && <RequireHint />}
            <ProductHandler />
            <ProductLoader />
            <div className="px-2 pt-2">
              <Row>
                <ProviderSelect onlyAllowBasic={requireDeliveryProduct} />
                <Col>
                  <DateSelect isMixedTransport={isMixedTransport} />
                </Col>
                <ProviderLogo />
              </Row>
              <ProductSelect />
            </div>
          </ProductsContextProvider>
        </Card>
      )}
    </>
  )
}

export default Transport
